import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  IconButton,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import * as React from "react";

import { EditFieldButton } from "@/shared/components/EditFieldButton";
import { UpdateActionRequest } from "@/shared/domain/actions/ActionRecord";
import { OrgRecord } from "@/shared/domain/orgs";

import { ImageSelector } from "../image/ImageSelector";

interface EditableActionImageProps {
  imageUri: string | undefined;
  currentOrg: OrgRecord | null;
  onChange: (updates: UpdateActionRequest) => void;
  setErrorText: (arg: string) => void;
  onHelperClick?: () => void;
  canEdit?: boolean;
}

export function EditableActionImage({
  imageUri,
  currentOrg,
  onChange,
  setErrorText,
  onHelperClick,
  canEdit = false,
}: EditableActionImageProps) {
  const theme = useTheme();
  const [showEditableIcon, setShowEditableIcon] = React.useState(false);
  const [editable, setEditable] = React.useState(false);
  const [currentImageUri, setCurrentImageUri] = React.useState<
    string | undefined
  >(imageUri);

  const updateImage = () => {
    setErrorText("");

    onChange({
      uri: currentImageUri || null,
    });
  };

  const onClickEditSave = () => {
    if (editable) {
      updateImage();
    }
    setEditable(!editable);
  };

  let content = currentImageUri;
  if (!currentImageUri) {
    content = "None";
  }

  return (
    <ListItem
      onMouseOver={() => {
        if (canEdit) {
          setShowEditableIcon(true);
        }
      }}
      onMouseLeave={() => {
        setShowEditableIcon(false);
      }}
    >
      <ListItemText
        primaryTypographyProps={{
          component: "span",
        }}
        sx={{
          mt: theme.spacing(0.5),
        }}
        primary={
          <>
            <span>Image</span>

            {onHelperClick && (
              <IconButton
                sx={{
                  p: "5px",
                  verticalAlign: "middle",
                  ml: theme.spacing(0.25),
                }}
                onClick={onHelperClick}
              >
                <InfoIcon
                  color="primary"
                  sx={{
                    fontSize: "1.1rem",
                    cursor: "pointer",
                  }}
                />
              </IconButton>
            )}

            <EditFieldButton
              editable={editable}
              showEditableIcon={showEditableIcon}
              onClick={onClickEditSave}
            />

            <Box>
              {editable === false ? (
                <Typography
                  component="span"
                  variant="body2"
                  style={{
                    whiteSpace: "pre-wrap",
                    color: theme.palette.text.secondary,
                    wordBreak: "break-word",
                  }}
                >
                  {content}
                </Typography>
              ) : (
                <Box marginTop={theme.spacing(0.5)}>
                  {currentOrg && (
                    <ImageSelector
                      currentOrg={currentOrg}
                      image={currentImageUri}
                      onSelectImage={setCurrentImageUri}
                    />
                  )}
                </Box>
              )}
            </Box>
          </>
        }
      />
    </ListItem>
  );
}
